<template>
  <el-dialog :title="getTitle"
             :visible.sync="showUser"
             :close-on-click-modal="false"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="userInfo"
               :rules="userRules"
               ref="userForm"
               label-width="90px"
               class="type-form">
        <el-form-item label="账户:"
                      prop="username">
          <el-input v-model="userInfo.username"
                    placeholder="建议姓名的全拼，不可重复(作为登录账号)"></el-input>
        </el-form-item>
        <el-form-item label="姓名:"
                      prop="fullname">
          <el-input v-model.trim="userInfo.fullname"
                    placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item v-if="data.type === 'add'"
                      label="密码:"
                      prop="password">
          <el-input type="password"
                    v-model.trim="userInfo.password"
                    placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="联系方式:"
                      prop="mobile">
          <el-input v-model.trim="userInfo.mobile"
                    placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="状态:"
                      prop="status"
                      required>
          <el-radio-group v-model="userInfo.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
          <p class="tips">
            正常状态员工帐号允许登录系统，停用状态员工帐号不能登录系统
          </p>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/user/add' || '/user/edit'"
                 type="primary"
                 @click="handleConfirm('userForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
import validate from '@/common/validate'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showUser: this.isShow,
      userInfo: {
        username: '',
        fullname: '',
        password: '',
        mobile: '',
        status: '1'
      },
      userRules: {
        username: [{ required: true, message: '请输入用户名' }],
        password: [
          { required: true, message: '请输入密码' },
          { validator: validate.validPassword, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系方式' },
          { validator: validate.tel, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加用户' : '编辑用户'
    }
  },
  created() {
    if (this.data.type === 'edit') {
      this.getInfo()
    }
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getUserInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.userInfo = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.data.type === 'add') {
            fetch.addUser({ ...this.userInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editUser({ ...this.userInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    }
  }
}
</script>

<style></style>
